import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@y42/environment';
import { GitHttpHeader, ORG_API_URL_PARAM } from '@y42/model';
import { Observable } from 'rxjs';
import { DataTest, RunTestRequestHttpModel, RunTestResponseHttpModel } from '../state/data-test.model';

@Injectable({ providedIn: 'root' })
export class DataTestHttpService {
  constructor(private readonly http: HttpClient) {}

  runTest(dataTest: DataTest, additionalHeaders?: HttpHeaders): Observable<RunTestResponseHttpModel> {
    const requestBody: RunTestRequestHttpModel = {
      config: dataTest,
    };
    return this.http.post<RunTestResponseHttpModel>(
      `${environment.url.data_test_api}/company/${ORG_API_URL_PARAM}/run-test`,
      requestBody,
      { headers: additionalHeaders },
    );
  }

  rerunTestSuite(path: string): Observable<void> {
    const headers = new HttpHeaders({
      [GitHttpHeader.Location]: encodeURI(path),
    });
    return this.http.post<void>(
      `${environment.url.data_test_api}/company/${ORG_API_URL_PARAM}/rerun-test-suite`,
      {},
      { headers },
    );
  }
}
